module.exports = __webpack_public_path__ + "img/help.2daf47d5.svg";